// extracted by mini-css-extract-plugin
export default {"root":"availableInfo-module__root--Mf8TY"};